// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operation-mode-time-row {
  display: inline-flex;
  align-items: flex-start;
}

.operation-mode-time-actions {
  display: inline-flex;
  align-items: flex-start;
}

.operation-mode-day-button,
.operation-mode-icon-button,
.operation-mode-control-button {
  box-sizing: border-box;
  height: 2.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.operation-mode-day-button,
.operation-mode-icon-button {
  min-width: 3.5rem;
}

.operation-mode-icon-button {
  width: 3.5rem;
  padding-left: 0;
  padding-right: 0;
}

.operation-mode-icon-button .in {
  line-height: 1;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
